export const SmoothScroll = (element, gotoX, gotoY, behavior) => {
  const c = window.pageYOffset || document.documentElement.scrollTop;
  const timing = behavior || 'auto';

  if (c >= 0) {
    element.scrollTo({
      top: gotoY,
      left: 0,
      behavior: timing
    });
  }
};
